import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { getCookie } from "typescript-cookie";
import {
  useAddWinterCerealFertilizerMutation,
  useDeleteWinterCerealFertilizerMutation,
  useEditWinterCerealFertilizerMutation
} from "../../../../redux/api/chemicalization/winterCerealFertilizer";
import { EntWinterCerealFertilizer } from "../../../../models/chemicalization/winterCerealFertilizer";


const useWinterCerealFertilizer = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [ addWinterCerealFertilizer ] = useAddWinterCerealFertilizerMutation();
  const [ deleteWinterCerealFertilizer ] = useDeleteWinterCerealFertilizerMutation();
  const [ editWinterCerealFertilizer ] = useEditWinterCerealFertilizerMutation();

  async function onAddWinterCerealFertilizer(newWinterCerealFertilizer: EntWinterCerealFertilizer): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addWinterCerealFertilizer(newWinterCerealFertilizer).then((response: any) => {
		if (response.error) {
		  const isKyrgyz = getCookie('i18next') === 'ky';
		  const lang = isKyrgyz ? 'kg' : 'ru';
		  const res = response.error.data?.res;
		  const errorMessages = Array.isArray(res)
			? res.map((error: any) => error[lang] || error.ru).join('\n')
			: response.error.data?.msg || t('unknownError');
		  throw new Error(errorMessages);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteWinterCerealFertilizer(winterCerealFertilizer: EntWinterCerealFertilizer) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteWinterCerealFertilizer(winterCerealFertilizer.id as number).then((response: any) => {
			if (response.error) {
			  const isKyrgyz = getCookie('i18next') === 'ky';
			  const lang = isKyrgyz ? 'kg' : 'ru';
			  const res = response.error.data?.res;
			  const errorMessages = Array.isArray(res)
				? res.map((error: any) => error[lang] || error.ru).join('\n')
				: response.error.data?.msg || t('unknownError');
			  throw new Error(errorMessages);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onEditWinterCerealFertilizer(editedWinterCerealFertilizer: EntWinterCerealFertilizer): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editWinterCerealFertilizer(editedWinterCerealFertilizer).then((response: any) => {
		if (response.error) {
		  const isKyrgyz = getCookie('i18next') === 'ky';
		  const lang = isKyrgyz ? 'kg' : 'ru';
		  const res = response.error.data?.res;
		  const errorMessages = Array.isArray(res)
			? res.map((error: any) => error[lang] || error.ru).join('\n')
			: response.error.data?.msg || t('unknownError');
		  throw new Error(errorMessages);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  return { onAddWinterCerealFertilizer, onDeleteWinterCerealFertilizer, onEditWinterCerealFertilizer }
}

export { useWinterCerealFertilizer };

